// libraries.
import { useState } from 'react';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import { rotatePlugin } from '@react-pdf-viewer/rotate';
import { thumbnailPlugin } from '@react-pdf-viewer/thumbnail';
import { Viewer, SpecialZoomLevel, Worker } from '@react-pdf-viewer/core';

// utils.
import { getFileType } from './utils';

// components.
import { ImgRotateButtons } from './ImgRotateButtons';

// styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/zoom/lib/styles/index.css';
import '@react-pdf-viewer/thumbnail/lib/styles/index.css';
import { ImgZoomButtons } from './ImgZoomButtons';
import { WrapperDocuments, WrapperThumbnails } from '../styles';

interface FileViewerProps {
  fileUrl: string;
  hideThumbnails?: boolean;
}

export const FileViewer = ({ fileUrl, hideThumbnails }: FileViewerProps) => {
  const fileType = getFileType(fileUrl);

  const zoomPluginInstance = zoomPlugin();
  const { ZoomInButton, ZoomOutButton } = zoomPluginInstance;

  const thumbnailPluginInstance = thumbnailPlugin();
  const { Thumbnails } = thumbnailPluginInstance;

  const rotatePluginInstance = rotatePlugin();
  const { RotateBackwardButton, RotateForwardButton } = rotatePluginInstance;

  const [rotation, setRotation] = useState(0);
  const handleRotateForward = () => setRotation(prev => prev + 90);
  const handleRotateBackward = () => setRotation(prev => prev - 90);

  const [scale, setScale] = useState(1);
  const handleZoomIn = () => setScale(prev => Math.min(prev + 0.2, 3));
  const handleZoomOut = () => setScale(prev => Math.max(prev - 0.2, 0.5));

  if (fileType === 'pdf') {
    return (
      <div className="d-flex h-100">
        {!hideThumbnails && (
          <WrapperThumbnails>
            <Thumbnails />
          </WrapperThumbnails>
        )}
        <WrapperDocuments>
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
            <div className="rotate-buttons">
              <div style={{ padding: '0px 2px' }}>
                <ZoomOutButton />
              </div>
              <div style={{ padding: '0px 2px' }}>
                <ZoomInButton />
              </div>
              <div style={{ padding: '0px 2px' }}>
                <RotateBackwardButton />
              </div>
              <div style={{ padding: '0px 2px' }}>
                <RotateForwardButton />
              </div>
            </div>
            <Viewer
              fileUrl={fileUrl}
              defaultScale={SpecialZoomLevel.PageWidth}
              plugins={[
                thumbnailPluginInstance,
                rotatePluginInstance,
                zoomPluginInstance,
              ]}
            />
          </Worker>
        </WrapperDocuments>
      </div>
    );
  }

  if (fileType === 'image') {
    return (
      <div className="d-flex h-100 w-100">
        <WrapperDocuments>
          <div className="rotate-buttons">
            <ImgZoomButtons onZoomIn={handleZoomIn} onZoomOut={handleZoomOut} />
            <ImgRotateButtons
              onRotateBackward={handleRotateBackward}
              onRotateForward={handleRotateForward}
            />
          </div>
          <div className="img-container">
            <img
              src={fileUrl}
              alt="Documento"
              className={rotation % 180 !== 0 ? 'rotated' : ''}
              style={{
                transform: `rotate(${rotation}deg) scale(${scale})`,
                transition: 'transform 0.3s',
              }}
            />
          </div>
        </WrapperDocuments>
      </div>
    );
  }

  return (
    <div className="d-flex justify-content-center align-items-center h-100">
      <p>Formato de archivo no soportado</p>
    </div>
  );
};
